export default "__VITE_ASSET__Ike4ujAr__"